const generateAccessoryCode = (type: string): string => {
  const typeMap: { [key: string]: string } = {
    'Düğme': 'BTN',
    'Fermuar': 'ZIP',
    'Toka': 'BCK',
    'Etiket': 'LBL',
    'Astar': 'LIN',
    'Diğer': 'OTH'
  };

  const date = new Date();
  const year = date.getFullYear().toString().slice(-2);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const random = Math.floor(Math.random() * 100).toString().padStart(2, '0');
  
  const typeCode = typeMap[type] || 'OTH';
  
  return `AKS${typeCode}${year}${month}${day}${random}`;
};

export default generateAccessoryCode;
